<template>
  <v-container>
    <v-row justify="center" align="center">
      <v-col cols="12" class="text-center">
        <span class="text-h6 font-weight-bold">Обновление данных</span>
        <v-divider class="my-2" />
      </v-col>
    </v-row>
    <v-row justify="center" align="center">
      <v-col cols="12" md="6" lg="6" xl="6">
        <v-card elevation="5" class="px-4 py-4">
          <v-card-text>
            <v-row>
              <v-col cols="12" class="text-center">
                <v-btn
                    class="purple darken-2 white--text"
                    tile
                    elevation="1"
                    @click="updateMP()"
                    >Обновить МП
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "Update",
  data: () => ({
  }),
  computed: {
    ...mapGetters({
        getMPStatus: "reportUpdate/GET_MP_STATUS",
    }),
  },
  methods: {
    ...mapActions({
      updateMedPred: "reportUpdate/UPDATE_MP",
      generateSnackbar: "snackbar/GENERATE_SNACKBAR",
    }),
    async updateMP() {
        await this.updateMedPred();
        this.generateSnackbar({
            show: true,
            timeout: 3000,
            color: "green",
            text: "Обновлёны МедПреды!",
        });
    },
  }
}
</script>